import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { legacyProfileQueries } from '@/entities/legacy-profile';
import { InvoicesPage } from '@/pages/invoices';
import { requireAuth } from '../require-auth';

/**
 * История запросов (Invoices) — the merchant's balance top-up request history.
 *
 * Lives under `/profile`, reached from the profile balance card's «История» button.
 * Preserves the old panel's `/profile/invoices` URL structure and pagination.
 */
const invoicesSearchSchema = z.object({
  page: z.number().int().min(1).default(1).catch(1),
  limit: z.number().int().min(1).default(15).catch(15),
});

export const Route = createFileRoute('/profile_/invoices')({
  beforeLoad: requireAuth,
  validateSearch: invoicesSearchSchema,
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(
      legacyProfileQueries.invoices({ limit: 15, skip: 0 }),
    );
  },
  component: InvoicesRoute,
});

function InvoicesRoute() {
  const { page, limit } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <InvoicesPage
      page={page}
      limit={limit}
      onPageChange={(next) =>
        void navigate({ search: (prev) => ({ ...prev, page: next }) })
      }
      onLimitChange={(next) =>
        void navigate({ search: (prev) => ({ ...prev, limit: next, page: 1 }) })
      }
    />
  );
}
